import { Icon, Page, PathButton } from "shared/react";
import { ATTEMPT_SCHEMA, ATTEMPT_STATUSES, type AttemptStatus, LEADERBOARD_MAX } from "shared/schema";
import { getImageStyle } from "shared/util/style";
import { USER } from "../util/user.js";
import { AttemptChallengeList } from "./ChallengeList.js";

export const CHALLENGES_STYLE = getImageStyle("/img/challenge.angled.svg", 336);

const NO_CHALLENGES = (
	<aside className="card pad-3x weight-bold targeted" style={getImageStyle("/img/hash.angled.svg", 97)}>
		<Icon icon="challenge" mods="size-3x" />
		<h2 className="space-none">Challenge yourself!</h2>
		<p className="space-none">Find something new to work on...</p>
		<a className="button target" href="/tag/explore">
			<span>Explore challenges</span> <Icon icon="right" />
		</a>
	</aside>
);

export function ChallengesPage({ status: unsafeStatus = "active" }: { status?: AttemptStatus }): React.ReactElement {
	const status = ATTEMPT_SCHEMA.props.status.validate(unsafeStatus);
	const title = `${ATTEMPT_STATUSES[status]} challenges`;
	return (
		<Page title={title} path={`/challenges/${status}`}>
			<header className="panel pad-none" style={CHALLENGES_STYLE}>
				<h1 className="space-none pad-2x">Challenges</h1>
				<nav className="pin-top pin-right flex-row">
					<PathButton mods="button-quiet" path="/search/challenges" title="Search challenges">
						<Icon icon="search" />
					</PathButton>
					<PathButton mods="button-quiet" path="/me/challenges/new" title="Create challenge">
						<Icon icon="add" />
					</PathButton>
				</nav>
				<nav className="space-none pad-none flex-row size-small width-wide">
					<PathButton mods="flex-third" path="/challenges/active">
						{ATTEMPT_STATUSES["active"]}
					</PathButton>
					<PathButton mods="flex-third" path="/challenges/completed">
						{ATTEMPT_STATUSES["completed"]}
					</PathButton>
					<PathButton mods="flex-third" path="/tag/explore">
						<span>Explore</span>
					</PathButton>
				</nav>
			</header>
			<AttemptChallengeList //
				query={{
					uid: USER.data.uid,
					status,
					$order: "!updated",
					$limit: LEADERBOARD_MAX,
				}}
				empty={`No ${status} challenges`}
			/>
			{status === "active" ? NO_CHALLENGES : null}
		</Page>
	);
}
